<template>
  <div @click.stop class="stamp">
    <div v-if="mode == 'add'">
      <div style="position:relative">
        <canvas :width="isSign ? 320 : 200" :height="isSign ? 100 : 200"
          style="background:url(/assets/grid.png)" />
        <canvas id="crop" :title="$t('크롭할 범위를 드래그하세요')" :width="isSign ? 320 : 200"
          :height="isSign ? 100 : 200" style="position:absolute;top:0;left:0" />
        <b-form-file v-show="!tmpFile" class="dropzone" v-model="tmpFile" accept=".png,.jpg,.gif"
          placeholder="Click or Drag & Drop" />
      </div>
      <div style="margin-left:10px">
        <b-form-group :label="$t('투명도')">
          <b-form-input class="mb-2" v-model="bound" type="range" />
        </b-form-group>
        <b-form-group :label="$t('배경 투명도')">
          <b-form-input class="mb-2" v-model="trans" type="range" />
        </b-form-group>
        <b-button block size="sm mb-2" @click="resetTmpFile" v-text="$t('초기화')" />
        <b-button v-if="showSave" @click="save" block size="sm" variant="primary" v-text="$t('저장 및 사용')" />
      </div>
    </div>
    <div v-else-if="mode == 'make'">
      <canvas width="200" height="200" />
      <div style="width:190px;margin-left:10px">
        <b-form-select class="mb-2" v-model="shape" :options="shapes" />
        <b-form-select class="mb-2" v-model="font" :options="fonts" />
        <b-form-textarea class="mb-2" v-model="txt" :maxlength="maxlength"
          :placeholder="$t('도장 내용 1~$자 입력', [maxlength])" />
        <b-button v-if="showSave" @click="save" block size="sm" variant="primary" v-text="$t('저장 및 사용')" />
      </div>
    </div>
    <div v-else-if="mode == 'sign'">
      <div style="position:relative;width:320px;height:100px">
        <div style="color:#ddd;padding-top:38px;height:100px;text-align:center" v-text="$t('여기에 서명하세요')" />
        <VueSignaturePad style="position:absolute;top:0;box-shadow:0 0 5px #bbb" width="320px" height="100px"
          ref="signPad" />
      </div>
      <div style="margin-left:10px">
        <b-button block size="sm mb-2" @click="add = true; $refs.signPad.clearSignature()" v-text="$t('초기화')" />
        <b-button v-if=" showSave " block size="sm" variant="primary" @click=" save " v-text=" $t('저장 및 사용') " />
      </div>
    </div>
    <div v-else>
      <b-button size="sm m-2" @click=" mode = 'add' " v-text=" $t('이미지 업로드') " />
      <b-button v-if=" type != 'stamp' " size="sm m-2" @click=" mode = 'sign' " v-text=" $t('사인 만들기') " />
      <b-button v-if=" type != 'sign2' " size="sm m-2" @click=" mode = 'make' " v-text=" $t('도장 만들기') " />
    </div>
  </div>
</template>

<style>
.stamp>div {
  min-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #ccc;
  border-radius: 10px;
  padding: 1em 0;
  margin-top: 7px;
}

.stamp .custom-file {
  position: absolute;
  inset: 0;
  background-color: transparent !important;
}

.stamp .custom-file-label {
  height: 100%;
  white-space: pre-wrap;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.stamp .custom-file-label::after {
  display: none;
}

.modal-form .stamp legend {
  justify-content: left;
}
</style>

<script>
import { loadImg, canvas2transparent } from '../utils';
// import { loadImg, canvas2transparent } from '../config';
let font;

export default {
  props: {
    type: { default: () => 'stamp' }, showSave: Boolean, currentType: Number,
  },
  data: () => ({
    timer: 0, imgs: [], mode: '', txt: '', tmpFile: null, bound: 50, trans: 50, crop: [0, 0, 1, 1], maxlength: 16, cropper: null,
    fonts: [], shapes: [], font: 'kr_js.otf', lastFont: null, shape: 'ceo',
  }),
  created() {
    this.fonts = [{ text: this.$t('한글 서체')+1, value: 'kr_js.otf' }, { text: this.$t('한글 서체')+2, value: 'kr_wi.woff2' }, { text: this.$t('한글 서체')+3, value: 'kr_mp.woff2' }, { text: this.$t('한글 서체')+4, value: '궁서체' }, { text: this.$t('한자 서체')+1, value: 'cn2.woff2' }, { text: this.$t('한자 서체')+2, value: 'cn3.woff2' }];
    this.shapes = [{ text: this.$t('대표이사 도장'), value: 'ceo' }, { text: this.$t('원형 도장'), value: 'bg1' }, { text: this.$t('타원형 도장'), value: 'bg2' }];
  },
  computed: {
    isSign() {
      return this.currentType === 2
    }
  },
  watch: { tmpFile: 'preview', bound: 'preview', trans: 'preview', mode: 'preview', txt: 'preview', shape: 'preview', font: 'preview' },
  methods: {
    resetTmpFile() {
      this.tmpFile = null;
      this.crop = [0, 0, 1, 1];
      const canvas = this.$el.querySelector('canvas');
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    },
    preview() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        if (this.mode == 'make') {
          this.maxlength = ({ ceo: 12, bg1: 6, bg2: 4 })[this.shape];
          const fontNm = ['kr', 'cn'].includes(this.font.slice(0, 2)) ? 'StampFont' : this.font;
          if (this.lastFont != this.font) {
            this.lastFont = this.font;
            if (font) {
              document.fonts.delete(font);
              font = null;
            }
            if (fontNm == 'StampFont') {
              font = new FontFace('StampFont', `url(/assets/font_${this.font})`);
              document.fonts.add(font);
              try { await font.load() } catch (e) { console.log(e) }
            }
          }
          const canvas = this.$el.querySelector('canvas'), ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(await loadImg(`/assets/stamp_${this.shape}.png`), 0, 0, canvas.width, canvas.height);
          ctx.fillStyle = '#e02';
          ctx.font = `${this.shape == 'ceo' ? 30 : 40}px "${fontNm}"`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          if (this.shape == 'ceo') {
            ctx.translate(100, 100);
            for (const t of this.txt) {
              ctx.rotate(Math.PI * 2 / (this.txt.length + 1));
              ctx.fillText(t, 0, -69);
            }
          }
          else if (this.shape == 'bg2') {
            if (this.txt.length == 1) {
              ctx.scale(2, 3.3);
              ctx.fillText(this.txt, 50, 30);
            }
            else if (this.txt.length == 2) {
              ctx.scale(2, 1.75);
              ctx.fillText(this.txt.charAt(0), 50, 40);
              ctx.fillText(this.txt.charAt(1), 50, 79);
            }
            else if (this.txt.length == 3) {
              ctx.scale(2, 1.2);
              ctx.fillText(this.txt.charAt(0), 50, 42);
              ctx.fillText(this.txt.charAt(1), 50, 82);
              ctx.fillText(this.txt.charAt(2), 50, 122);
            }
            else {
              ctx.scale(2, 0.8);
              ctx.fillText(this.txt.charAt(0), 50, 60);
              ctx.fillText(this.txt.charAt(1), 50, 101);
              ctx.fillText(this.txt.charAt(2), 50, 143);
              ctx.fillText(this.txt.charAt(3), 50, 184);
            }
          }
          else {
            if (this.txt.length > 1 && this.txt.length % 2) this.txt += this.font.startsWith('cn') ? '印' : '인';
            if (this.txt.length == 1) {
              ctx.scale(3, 3);
              ctx.fillText(this.txt, 33, 35);
            }
            else if (this.txt.length == 2) {
              ctx.scale(1.8, 2.8);
              ctx.fillText(this.txt, 55, 35);
            }
            else if (this.txt.length == 4) {
              ctx.scale(1.75, 1.65);
              ctx.fillText(this.txt.slice(0, 2), 56, 40);
              ctx.fillText(this.txt.slice(2), 56, 79);
            }
            else {
              ctx.scale(1.1, 1.65);
              ctx.fillText(this.txt.slice(0, 3), 90, 40);
              ctx.fillText(this.txt.slice(3, 6), 90, 79);
            }
          }
          ctx.resetTransform();
          return;
        }
        else if (!this.tmpFile) return;
        const canvas = this.$el.querySelector('canvas'), ctx = canvas.getContext('2d');
        const img = await loadImg(URL.createObjectURL(this.tmpFile));
        const crop = [img.naturalWidth * this.crop[0], img.naturalHeight * this.crop[1], img.naturalWidth * this.crop[2], img.naturalHeight * this.crop[3]];
        const ratio = Math.min(canvas.width / crop[2], canvas.height / crop[3]);
        const cx = (canvas.width - crop[2] * ratio) / 2, cy = (canvas.height - crop[3] * ratio) / 2;
        ctx.imageSmoothingEnabled = true;
        if (!this.cropper) this.cropper = this.setCropper(cx / canvas.width, cy / canvas.height);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, crop[0], crop[1], crop[2], crop[3], cx, cy, crop[2] * ratio, crop[3] * ratio);
        canvas2transparent(canvas, 700 - this.bound * 4, 400 - this.trans * 3);
      }, this.timer ? 500 : 0);
    },
    setCropper(cx, cy) {
      var canvas = this.$el.querySelector('#crop');
      var ctx = canvas.getContext('2d');
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#f00';
      var sX, sY, cX, cY;
      var canvasX = canvas.offsetLeft;
      var canvasY = canvas.offsetTop;
      var draw = false;
      canvas.onmousedown = e => {
        sX = parseInt(e.layerX - canvasX);
        sY = parseInt(e.layerY - canvasY);
        draw = true;
      };
      canvas.onmousemove = e => {
        if (draw) {
          cX = parseInt(e.layerX - canvasX);
          cY = parseInt(e.layerY - canvasY);
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.strokeRect(sX, sY, cX - sX, cY - sY);
        }
      };
      canvas.onmouseleave = () => draw = false;
      canvas.onmouseup = () => {
        draw = false;
        var threshold = 10;
        if (Math.abs(cX - sX) > threshold && Math.abs(cY - sY) > threshold) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          const w = canvas.width * (1 - cx * 2), h = canvas.width * (1 - cy * 2);
          this.crop = [this.crop[0] + (sX / canvas.width - cx) * this.crop[2], this.crop[1] + (sY / canvas.height - cy) * this.crop[3], (cX - sX) / w * this.crop[2], (cY - sY) / h * this.crop[3]]
          // console.log(this.crop);
          this.cropper = null;
          this.preview();
        }
      };
      return true;
    },
    save() {//(name = 'stamp.png') {
      return new Promise(res => {
        const canvas = this.$el.querySelector('canvas');
        if (!canvas || !canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height).data.some(channel => channel !== 0)) return this.$emit('save', {});
        canvas.toBlob(blob => res(this.$emit('save', { blob, name: this.mode == 'add' ? this.tmpFile.name.slice(this.tmpFile.name.lastIndexOf('.') + '.png') : this.mode == 'make' ? this.txt + '.png' : 'SignPad.png' })), 'image/png');
      });
    },
  },
}
</script>